import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section aria-labelledby="pain-title" className="bg-cream px-5 py-20 md:py-28" data-id="element-163" data-mp="2wp1cnq5w8mnt">
      <Reveal className="mx-auto max-w-content" data-id="element-164" data-mp="2wmopmyla3m3w">
        <div className="mx-auto max-w-2xl text-center" data-id="element-165" data-mp="2roww604zjrxl">
          <h2 id="pain-title" className="flex items-center justify-center gap-3 text-3xl font-extrabold leading-tight tracking-tight text-pine md:text-4xl" data-id="element-166" data-mp="35ppuyx2bl96i">
            <HelpCircleIcon className="h-7 w-7 shrink-0 text-turquoise" strokeWidth={2} aria-hidden="true" data-id="element-167" data-mp="30osb8g1nw72w" />
            Does This Sound Like You?
          </h2>
          <p className="mt-4 text-slate-body" data-id="element-168" data-mp="3ahr5adfxgptw">
            You are not alone. This is exactly how most lacrosse coaches feel.
          </p>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-169" data-mp="3kevqa9y1ef94">
          {painPoints.map(({
          title,
          description
        }, index) => <article key={title} className="flex flex-col rounded-card bg-white p-7 text-left shadow-card" data-id="element-170" data-mp="svjgtkbzz3j7" data-mpi={index}>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-pine font-display text-sm font-bold text-white" data-id="element-171" data-mp="wxemt24vi53b">
                {index + 1}
              </span>
              <h3 className="mt-5 text-lg font-bold leading-snug text-pine" data-id="element-172" data-mp="16usyypjrk7pt">{title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-body" data-id="element-173" data-mp="1bu5ndeqa9mui">{description}</p>
            </article>)}
        </div>
        <p className="mt-12 text-center font-display text-xl font-bold italic text-amber md:text-2xl" data-id="element-174" data-mp="1fto7w9e6zvwt">
          And you deserve far better than guessing.
        </p>
      </Reveal>
    </section>;
}